import { ErrorService } from './ErrorService';
import { ErrorType } from './ErrorType.enum';

export default {
	ErrorService,
	ErrorType,
};
